<script setup lang="ts">
import { navigationRoutes } from '@/router/routes'
import { VNavigationDrawer, VListItem, VList } from 'vuetify/components'
import { APP_NAME, NAVBAR_WIDTH, COLLAPSED_NAVBAR_WIDTH, APP_VERSION } from '@/utils/constants'
import { BaseButton } from '@/components/base'
import { routeAssets } from '@/router/routes-assets'
import type { RouteComponent, RouteRecordRaw } from 'vue-router'
import { NavbarLogo } from '@/assets'
import CONSTANTS from '@/utils/constants/string-constants'

const isNavbarCollapsed = defineModel<boolean>({ default: true })
type RouteType = { name: string; path: string; component: RouteComponent } | RouteRecordRaw

const getRouteAsset = (route: RouteType) => `mdi:mdi-${routeAssets[route.path]}`
</script>
<template>
  <v-navigation-drawer
    absolute
    color="brand_dark"
    class="hide-scrollbar"
    permanent
    :width="NAVBAR_WIDTH"
    :rail="isNavbarCollapsed"
    :rail-width="COLLAPSED_NAVBAR_WIDTH"
  >
    <BaseButton
      size="32"
      height-variant="auto"
      class="collapse-button bg-white"
      @click="() => (isNavbarCollapsed = !isNavbarCollapsed)"
    >
      <v-icon icon="mdi:mdi-chevron-left" size="24" :rotate-180="isNavbarCollapsed" />
    </BaseButton>
    <v-list-item class="navbar-logo mt-1 px-3">
      <img :src="NavbarLogo" :alt="CONSTANTS.NAV_LOGO_TEXT" width="auto" />
    </v-list-item>
    <v-list density="compact" nav class="px-3 mb-2">
      <v-list-item
        v-for="(route, index) in navigationRoutes"
        :key="index"
        :to="route.path"
        class="nav-item-padding py-3 mb-2 d-flex align-center nav-item-border body-1--new"
        active-class="active-nav"
      >
        <v-icon :icon="getRouteAsset(route)" :size="18" class="mr-3" />
        {{ route.name }}
      </v-list-item>
    </v-list>
    <div v-if="!isNavbarCollapsed" class="body-2 mx-4 mt-2 mb-2 w-100">
      <div class="pb-1">
        Version: <span class="text-white">{{ APP_VERSION }}</span>
      </div>
      <!-- <div>
        &copy; {{ new Date().getFullYear() }} {{ APP_NAME }}</div
      > -->
    </div>
  </v-navigation-drawer>
</template>
<style scoped lang="scss">
.navbar-logo {
  font-size: 24px;
  line-height: 28.64px;
  font-weight: 900;
  letter-spacing: 2%;
  background: rgb(16 75 74);
}

.collapse-button {
  border: 1px solid #4a5b6b;
  border-radius: 6px;
  position: absolute;
  right: 0;
  top: calc(0.5 * 88px);
  transform: translate(50%, -50%);
  z-index: 1;

  .v-icon[rotate-180='true'] {
    transition: transform 0.6s cubic-bezier(0.075, 0.82, 0.165, 1);
    transform: rotate(180deg);
  }
}

.nav-item-border {
  border: 0.5px solid #286967;
}

.active-nav {
  background: #2a5643;
  color: #ffe800 !important;
  border: 0.5px solid #6a822f;
}

.nav-item-padding {
  padding-left: 24px;
  padding-right: 24px;
}
</style>
